/**
 * User-related TypeScript types
 * SHARED between frontend and backend
 * ABSOLUTE RULE: NO 'any' types allowed
 */

import { Timestamp } from 'firebase/firestore';

export enum UserRole {
  USER = 'USER',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export interface WatermarkConfig {
  enabled: boolean;
  logoUrl: string | null;
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'center';
  opacity: number;
  scale: number;
}

export interface UserDocument {
  uid: string;
  email: string;
  displayName: string | null;
  photoURL: string | null;
  role: UserRole;
  credits: number;
  storageUsed: number; // in bytes
  storageLimit: number; // in bytes (default 250MB)
  watermarkConfig?: WatermarkConfig;
  createdAt: Timestamp;
  lastLogin: Timestamp;
}

export interface UserCreditsUpdate {
  uid: string;
  creditsToAdd: number;
  reason: string;
}
